/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import TimePending from './TimePending';
import Approved from './Approved';
import Reject from './Reject';

const Requesttab = () => {
  const [activeTab, setActiveTab] = useState('pending');

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="card-body">
                  <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
                        onClick={() => setActiveTab('pending')}
                        role="tab"
                      >
                        <span className="d-none d-md-block">Pending</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-home-variant h5"></i>
                        </span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'approved' ? 'active' : ''}`}
                        onClick={() => setActiveTab('approved')}
                        role="tab"
                      >
                        <span className="d-none d-md-block">Approved</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'rejected' ? 'active' : ''}`}
                        onClick={() => setActiveTab('rejected')}
                        role="tab"
                      >
                        <span className="d-none d-md-block">Rejected</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content mt-3">
                    {activeTab === 'pending' && <TimePending />}
                    {activeTab === 'approved' && <Approved />}
                    {activeTab === 'rejected' && <Reject />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default Requesttab;
